import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TableCell, TableRow, Grid, Card } from '@material-ui/core';
import moment from 'moment';
import API from 'apis/API';
import Routes from 'router/Routes';
import PaginatedTable from 'components/Table/PaginatedTable';
import { ViewIconButton, DeleteIconButton } from 'components/Buttons/IconButtons';
import FillButton from "../../components/Buttons/FillButton";
import Dropdown from 'components/Form/PlainInputs/Dropdown';
import DateInput from 'components/Form/DateInput';
import { makeStyles } from '@material-ui/styles';
import { useParams } from "react-router-dom";
//import getTelemetryModulesName from "../../utils/getTelemetryModulesName";

let dateFrom, dateTo, wrongDates;

const useStyles = makeStyles((theme) => ({
    row: {
        alignItems: 'center',
        paddingTop: 10
    },
    label: {
        fontSize: 14,
        fontWeight: 700,
    },
    errorLabel: {
        fontSize: 18,
        fontWeight: 700,
        color: 'red',
        marginTop: '10px',
        textAlign: 'center'  
    }
}));

const Students = props => {
    const history = useHistory();
    const { title } = props;

    let { timeFrom, timeTo, timeMode } = useParams();

    const [datesMode, setDatesMode] = useState(timeMode || 0);
    const [startDate, setStartDate] = useState(timeFrom > 0 ? moment.unix(timeFrom / 1000).format('MM/DD/YYYY') : null);
    const [endDate, setEndDate] = useState(timeTo > 0 ? moment.unix(timeTo / 1000).format('MM/DD/YYYY') : null);

    const classes = useStyles();

    const columns = [
        {
            title: 'Moduł',
            name: 'from',
        },
        /*{
            title: 'Akcja',
            name: 'to',
        },*/
        {
            title: 'Liczba kliknięć',
            name: 'clicks',
        },
        {
            title: 'Liczba osób',
            name: 'students',
            width: 100
        },
        {
            title: 'Akcje',
            name: 'action',
            width: 100
        },
    ];

    const renderRow = (item, index) => (
        <TableRow key={index} >
            <TableCell>{/*getTelemetryModulesName*/(item.orig)}</TableCell>
            {/*<TableCell>{item.to}</TableCell>*/}
            <TableCell>{item.clicks}</TableCell>
            <TableCell>{item.students}</TableCell>
            <TableCell>
                <Grid container>
                    <Grid item xs={6}>
                        <ViewIconButton onClick={() => history.push(Routes.Students.ActivityFrom(item.from, datesMode, dateFrom, dateTo))} />
                    </Grid>
                </Grid>
            </TableCell>
        </TableRow>
    );

    const exportXlsx = () => {
        dateFrom = false
        dateTo = false
        wrongDates = false
        const dayMS = 60 * 60 * 24 * 1000
        if (datesMode == 1)
        {
            dateFrom = moment().valueOf() - 8 * dayMS
        }
        else if (datesMode == 2)
        {
            dateFrom = moment().valueOf() - 32 * dayMS
        }
        else if (datesMode == 3)
        {
            dateFrom = moment().valueOf() - 366 * dayMS
        }
        else if (datesMode == 4)
        {
            dateFrom = startDate ? moment(startDate).valueOf() : false
            dateTo = endDate ? moment(endDate).valueOf()  + dayMS : false
            if (dateFrom && dateTo && dateFrom > dateTo)
            {
                dateFrom = false
                dateTo = false
                wrongDates = true
            }
        }
        let url = API.students.activityXls 
        if (dateFrom)
        {
            url += '?timeFrom=' + dateFrom
        }
        if (dateTo)
        {
            url += (dateFrom ? '&' : '?') + 'timeTo=' + dateTo
        }
        window.open(url)
    }

    const buttons = [
        {
            component: FillButton,
            title: 'Pobierz do XLSX',
            onClick: exportXlsx
        },
    ];

    const datesOptions = [
        {
            title: 'Wszystkie daty',
            id: '0'
        },
        {
            title: 'W zeszłym tygodniu',
            id: '1'
        },
        {
            title: 'W zeszłym miesiącu',
            id: '2',
        },
        {
            title: 'W zeszłym roku',
            id: '3',
        },
        {
            title: 'Wprowadź daty...',
            id: '4'
        }
    ]

    const handleDatesModeChange = e => {
        setDatesMode(e.target.value)
    }

    const handleStartDateChange = e => {
        setStartDate(e.target.value?.substring(0, 10))
    }

    const handleEndDateChange = e => {
        setEndDate(e.target.value?.substring(0, 10))
    }

    dateFrom = false
    dateTo = false
    wrongDates = false
    const dayMS = 60 * 60 * 24 * 1000
    if (datesMode == 1)
    {
        dateFrom = moment().valueOf() - 8 * dayMS
    }
    else if (datesMode == 2)
    {
        dateFrom = moment().valueOf() - 32 * dayMS
    }
    else if (datesMode == 3)
    {
        dateFrom = moment().valueOf() - 366 * dayMS
    }
    else if (datesMode == 4)
    {
        dateFrom = startDate ? moment(startDate).valueOf() : false
        dateTo = endDate ? moment(endDate).valueOf() + dayMS : false
        if (dateFrom && dateTo && dateFrom > dateTo)
        {
            dateFrom = false
            dateTo = false
            wrongDates = true
        }
    }

    return (
        <>        
        <Grid container spacing={3}>
            <Grid item xs={3}>
                <Card>
                    <Dropdown
                        name={'reminder_id'}
                        value={datesMode}
                        options={datesOptions}
                        onChange={handleDatesModeChange}
                    />
                    {datesMode == 4 && <>
                        <Grid container className={classes.row}>
                            <Grid xs={2}><label className={classes.label}>Od:</label></Grid>
                            <Grid xs={10}><DateInput
                                name={'start_date'}
                                value={startDate}
                                onChange={handleStartDateChange}
                                //error={errors?.start_date}
                            /></Grid>
                        </Grid>
                         
                        <Grid container className={classes.row}>
                            <Grid xs={2}><label className={classes.label}>Do:</label></Grid>
                            <Grid xs={10}><DateInput
                                name={'end_date'}
                                value={endDate}
                                onChange={handleEndDateChange}
                                //error={errors?.end_date}
                            /></Grid>
                        </Grid>

                        {wrongDates && <p className={classes.errorLabel}>Błędne daty!</p>}
                    </>}
                </Card>
            </Grid>
        </Grid>        

        <PaginatedTable
            title={title}
            buttons={buttons}
            //endpoint={API.students.activity}
            endpoint={params => API.students.activity({
                ...params,
                ...(dateFrom ? {timeFrom: dateFrom} : {}),
                ...(dateTo ? {timeTo: dateTo} : {}),
            })}
            columns={columns}
            renderRow={renderRow}
        />
        </>
    );
};

export default Students;
